import React from 'react';

function QuestionActionBar({ hideNavBar, handleQuestionBar }) {
    return (
        <div className="admin-recruit-account-card bg-white p-3 mt-4">
            <div className="d-flex justify-content-between">
                <div className="d-flex">
                    <button
                        onClick={() => {
                            handleQuestionBar('1');
                        }}
                        className="admin-recruit-form-btn btn p-2 font-13 semibold-text mb-0 me-4"
                    >
                        <span className="me-2">
                            <img src="/Images/recruit-choice-icon.svg" alt="icon" />
                        </span>
                        Choice
                    </button>
                    <button
                        onClick={() => {
                            handleQuestionBar('4');
                        }}
                        className="admin-recruit-form-btn btn p-2 font-13 semibold-text mb-0 me-4"
                    >
                        <span className="me-2">
                            <img src="/Images/recruit-text-icon.svg" alt="icon" />
                        </span>
                        Text
                    </button>
                    <button
                        onClick={() => {
                            handleQuestionBar('2');
                        }}
                        className="admin-recruit-form-btn btn p-2 font-13 semibold-text mb-0 me-4"
                    >
                        <span className="me-2">
                            <img src="/Images/recruit-checkbox-icon.svg" alt="icon" />
                        </span>
                        checkbox
                    </button>
                    <button
                        onClick={() => {
                            handleQuestionBar('3');
                        }}
                        className="admin-recruit-form-btn btn p-2 font-13 semibold-text mb-0 me-4"
                    >
                        <span className="me-2">
                            <img src="/Images/recruit-calendars.svg" alt="icon" />
                        </span>
                        Date
                    </button>
                    <button
                        onClick={() => {
                            handleQuestionBar('5');
                        }}
                        className="admin-recruit-form-btn btn p-2 font-13 semibold-text mb-0 me-4"
                    >
                        <span className="me-2">
                            <img src="/Images/recruit-top-up.svg" alt="icon" />
                        </span>
                        File Upload
                    </button>
                </div>
                <button
                    onClick={() => {
                        hideNavBar();
                    }}
                    className="btn p-2 font-13 semibold-text mb-0"
                >
                    <img src="/Images/recruit-cross.svg" alt="icon" />
                </button>
            </div>
        </div>
    );
}

export default QuestionActionBar;
